import { styled } from '@mui/system';

export const FooterContainer = styled('div')(({ theme }) => ({
	padding: theme.spacing(2),
	width: '100%',
	textAlign: 'center'
}));

export const ContactIcon = styled('div')(({ theme }) => ({
	marginRight: theme.spacing(1),
	marginTop: theme.spacing(0.5),
	color: theme.palette.primary.main
}));
